const isDigits = (v) => /^\d+$/.test(v);
const isToken = (v) => /^[\w -]{1,40}$/.test(v);

const SAFE_SEARCH_PARAMS = new Map([
  ['page', isDigits],
  ['limit', isDigits],
  ['offset', isDigits],
  ['sort_by', (v) => /^[\w.]{1,64}$/.test(v)],
  ['sort_order', (v) => /^(asc|desc)$/i.test(v)],
  ['id', isDigits],
  ['organizationId', isDigits],
  ['organization_id', isDigits],
  ['facilityId', isDigits],
  ['facility_id', isDigits],
  ['status', isToken],
  ['tab', isDigits],
  ['quickFilter', isToken],
  ['adminUiType', (v) => v === 'admin'],
  ['download', (v) => v === 'true' || v === 'false'],
]);

const TOKEN_PLACEHOLDER = ':token';
// Paths whose next segment is an activation credential (page and API).
const PATHS_WITH_TOKEN = new Set(['activation']);

// The router and API match paths case-insensitively, and URL.pathname keeps percent escapes.
const normalizeSegment = (segment) => {
  try {
    return decodeURIComponent(segment).toLowerCase();
  } catch {
    return segment.toLowerCase();
  }
};

export const scrubPathname = (pathname) => {
  const segments = pathname.split('/');
  const normalized = segments.map(normalizeSegment);

  return segments
    .map((segment, index) =>
      segment && PATHS_WITH_TOKEN.has(normalized[index - 1] ?? '')
        ? TOKEN_PLACEHOLDER
        : segment,
    )
    .join('/');
};

const RELATIVE_SCRUB_BASE = 'https://relative.invalid';

const scrubRelativeUrl = (raw) => {
  const isRooted = raw.startsWith('/');
  const scrubbed = scrubUrl(
    `${RELATIVE_SCRUB_BASE}${isRooted ? '' : '/'}${raw}`,
  ).slice(RELATIVE_SCRUB_BASE.length);

  return isRooted ? scrubbed : scrubbed.replace(/^\//, '');
};

export const scrubUrl = (raw) => {
  if (!raw) return raw;

  let url;
  try {
    url = new URL(raw);
  } catch {
    return scrubRelativeUrl(raw);
  }

  url.pathname = scrubPathname(url.pathname);

  for (const key of new Set(url.searchParams.keys())) {
    const isAllowedValue = SAFE_SEARCH_PARAMS.get(key);
    if (
      !isAllowedValue ||
      !url.searchParams.getAll(key).every(isAllowedValue)
    ) {
      url.searchParams.delete(key);
    }
  }

  url.username = '';
  url.password = '';
  url.hash = '';

  return url.toString();
};
